module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBracelets.c167e80.webp";